"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.to-string");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NaVButtons = exports.ReviewPage = exports.ReviewTable = exports.ForMoreInformation = exports.ThankYou = exports.CopyRight = exports.Title = exports.TitleText = exports.PageContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _formElements = require("@evidation/form-elements");

var PageContainer = _styledComponents["default"].div.withConfig({
  displayName: "components__PageContainer",
  componentId: "sc-4enbm1-0"
})(["display:flex;flex-flow:column nowrap;min-height:67vh;"]);

exports.PageContainer = PageContainer;

var TitleText = _styledComponents["default"].div.withConfig({
  displayName: "components__TitleText",
  componentId: "sc-4enbm1-1"
})(["@media (max-width:450px){p{font-size:11px !important;}}ul{list-style:none;padding-left:30px;}"]);

exports.TitleText = TitleText;

var Title = function Title() {
  return /*#__PURE__*/_react["default"].createElement(TitleText, null, /*#__PURE__*/_react["default"].createElement("h3", {
    style: {
      textAlign: 'center'
    }
  }, "Epworth Sleepiness Scale"), /*#__PURE__*/_react["default"].createElement("p", null, "How likely are you to doze off or fall asleep in the following situations, in contrast to feeling just tired?"), /*#__PURE__*/_react["default"].createElement("p", null, "This refers to your usual way of life in recent times."), /*#__PURE__*/_react["default"].createElement("p", null, "Even if you haven't done some of these things recently try to work out how they would have affected you."), /*#__PURE__*/_react["default"].createElement("p", null, "Use the following scale to choose the ", /*#__PURE__*/_react["default"].createElement("b", null, "most appropriate number"), " for each situation:"), /*#__PURE__*/_react["default"].createElement("ul", {
    style: {
      listStyle: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("p", null, "0 = would ", /*#__PURE__*/_react["default"].createElement("b", null, "never"), " doze")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("p", null, "1 = ", /*#__PURE__*/_react["default"].createElement("b", null, "slight chance"), " of dozing")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("p", null, "2 = ", /*#__PURE__*/_react["default"].createElement("b", null, "moderate chance"), " of dozing")), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("p", null, "3 = ", /*#__PURE__*/_react["default"].createElement("b", null, "high chance"), " of dozing"))), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      textAlign: 'center',
      marginTop: '30px',
      marginBottom: '15px'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("i", null, "It is important that you answer each question as best you can."))));
};

exports.Title = Title;

var CopyRight = function CopyRight() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      alignSelf: 'center',
      marginTop: 'auto'
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      fontSize: '9px'
    }
  }, "ESS \xA9 MW Johns 1990-1997. Used under License."));
};

exports.CopyRight = CopyRight;

var ThankYou = function ThankYou() {
  return /*#__PURE__*/_react["default"].createElement("h3", {
    style: {
      margin: 'auto',
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("b", null, /*#__PURE__*/_react["default"].createElement("i", null, "Thank you for your cooperation")));
};

exports.ThankYou = ThankYou;

var ForMoreInformation = function ForMoreInformation() {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      textAlign: 'center'
    }
  }, "For more information on the use of the ESS, please contact Mapi Research Trust, Lyon, France."), /*#__PURE__*/_react["default"].createElement("p", {
    style: {
      textAlign: 'center',
      marginTop: '30px'
    }
  }, "Internet:", ' ', /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://eprovide.mapi-trust.org"
  }, "https://eprovide.mapi-trust.org")));
};

exports.ForMoreInformation = ForMoreInformation;

var ReviewTable = _styledComponents["default"].table.withConfig({
  displayName: "components__ReviewTable",
  componentId: "sc-4enbm1-2"
})(["@media (max-width:450px){font-size:11px !important;line-height:1.5;margin-bottom:0;tr td:last-child{padding:5px;p{font-size:11px !important;margin:0;}}}"]);

exports.ReviewTable = ReviewTable;

var LittleP = _styledComponents["default"].p.withConfig({
  displayName: "components__LittleP",
  componentId: "sc-4enbm1-3"
})(["font-size:9px !important;margin-bottom:0;@media (min-width:451px){font-size:11px !important;}"]);

var ReviewPage = function ReviewPage(_ref) {
  var setQuestionIndex = _ref.setQuestionIndex,
      _ref$questions = _ref.questions,
      questions = _ref$questions === void 0 ? [] : _ref$questions,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? {} : _ref$values,
      _ref$answer_labels = _ref.answer_labels,
      answer_labels = _ref$answer_labels === void 0 ? [] : _ref$answer_labels;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", null, "Please review your answers"), /*#__PURE__*/_react["default"].createElement(LittleP, null, "*click on an answer to change your selection"), /*#__PURE__*/_react["default"].createElement(ReviewTable, null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Situation"), /*#__PURE__*/_react["default"].createElement("th", null, "Answer"))), /*#__PURE__*/_react["default"].createElement("tbody", null, questions.map(function (q, i) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: i
    }, /*#__PURE__*/_react["default"].createElement("td", null, q), /*#__PURE__*/_react["default"].createElement("td", {
      style: {
        cursor: 'pointer'
      },
      onClick: function onClick() {
        return setQuestionIndex(i);
      }
    }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, answer_labels[values["ess_".concat(i + 1)]])));
  }))));
};

exports.ReviewPage = ReviewPage;
var navCss = (0, _styledComponents.css)(["& >:first-child{padding:0px 10px 0px 0px;}& >:last-child{padding:0px 0px 0px 10px;}"]);

var NaVButtons = _styledComponents["default"].div.withConfig({
  displayName: "components__NaVButtons",
  componentId: "sc-4enbm1-4"
})(["display:flex;& > *{width:100%;}", ""], function (p) {
  return p.onBack && !p.hideNext && navCss;
});

exports.NaVButtons = NaVButtons;